import React, { useState } from "react";
import { Dialog, DialogActions, Button, TextareaAutosize, Typography, Divider } from "@mui/material";

interface AddOptionsDialogProps {
    open: boolean;
    onClose: () => void;
    onBulkPaste: (options: string[]) => void;
    chipLabel?: string;
}

const AddOptionsDialog: React.FC<AddOptionsDialogProps> = ({ open, onClose, onBulkPaste, chipLabel }) => {
    const [pasteValue, setPasteValue] = useState("");

    const handleBulkPaste = () => {
        const newOptions = pasteValue
            .split("\n")
            .map((option) => option.trim())
            .filter((option) => option !== "");
            const uniqueOptions = Array.from(new Set(newOptions)); 
        onBulkPaste(uniqueOptions);
        setPasteValue("");
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <div
          style={{
            padding: '24px',
            borderRadius: '12px',
            boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#fff',
          }}
        >
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography
              variant="h5"
              style={{
                fontFamily: 'Montserrat',
                fontWeight: '700',
                fontSize: '20px',
                color: '#333',
              }}
            >
              Paste Options
            </Typography>
          </div>
      
          <Divider style={{ margin: '16px 0' }} />
      
          {/* Textarea */}
          <TextareaAutosize
            placeholder={chipLabel === 'single_select' 
              ? `Paste options here, one per line...\n\nExample:\nOption 1\nOption 2\nOption 3\n\nFor single select with all fields:\nOption<::>Output Value<::>User Limit<::>Project Limit\nYes<::>yes<::>5<::>10\nNo<::>no<::>5<::>10`
              : `Paste options here, one per line...\n\nExample:\nOption 1\nOption 2\nOption 3`
            }
            value={pasteValue}
            onChange={(e) => setPasteValue(e.target.value)}
            style={{
              width: '100%',
              height: '120px',
              padding: '12px',
              border: '2px solid #ccc',
              borderRadius: '8px',
              fontSize: '16px',
              fontFamily: 'Arial, sans-serif',
              outline: 'none',
            }}
          />
      
          {/* Actions */}
          <DialogActions style={{ justifyContent: 'flex-end', marginTop: '16px' }}>
            <Button
              sx={{
                minWidth: '90px',
                minHeight: '44px',
                backgroundColor: '#F0F0F0',
                padding: '10px 20px',
                borderRadius: '8px',
                textTransform:'none',
                color: '#333',
                '&:hover': { backgroundColor: '#E0E0E0' },
              }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              sx={{
                minWidth: '120px',
                minHeight: '44px',
                backgroundColor: '#3D85C6',
                padding: '10px 20px',
                borderRadius: '8px',
                textTransform:'none',
                color: 'white',
                '&:hover': { backgroundColor: '#0056b3' },
              }}
              onClick={handleBulkPaste}
              disabled={!pasteValue.trim()}
            >
              Paste Options
            </Button>
          </DialogActions>
        </div>
      </Dialog>      
    );
};

export default AddOptionsDialog;
